const initialState = {
  data: [],
  success: false,
  error: false,
};

export const postRequest = (namespace) => (state = initialState, action) => {
  switch (action.type) {
    case `${namespace}/POST_REQUEST_REQUEST`: {
      return initialState;
    }
    case `${namespace}/POST_REQUEST_SUCCESS`: {
      return { ...state, data: action.data, success: true };
    }
    case `${namespace}/POST_REQUEST_FAILURE`: {
      return { ...state, data: action.error, success: false, error: true };
    }
    default:
      return state;
  }
};
